import favorites from '@/api/endpoints/favorites';
import financeServices from '@/api/endpoints/finance-services';
import purchase from '@/api/endpoints/purchase';
import testDrive from '@/api/endpoints/test-drive';
import user from '@/api/endpoints/user';
import vehicles from '@/api/endpoints/vehicles';

export default {
    favorites,
    financeServices,
    purchase,
    testDrive,
    user,
    vehicles,
};
